var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidemenuCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22758 6.10352e-05H1.77237C0.793604 6.10352e-05 0.000244141 0.793421 0.000244141 1.77219L0.000244141 8.22775C0.000244141 9.20651 0.793604 9.99987 1.77237 9.99987H8.22793C9.2067 9.99987 10.0001 9.20651 10.0001 8.22775L10.0001 1.77219C10.0001 0.793421 9.2067 6.10352e-05 8.22793 6.10352e-05H8.22758ZM1.1113 8.2274L1.1113 1.77219C1.1113 1.40762 1.40781 1.11111 1.77237 1.11111H2.88203L2.88203 8.88847H1.77237C1.40781 8.88847 1.1113 8.59196 1.1113 8.2274ZM8.88866 8.2274C8.88866 8.59196 8.59215 8.88847 8.22758 8.88847H3.99309L3.99309 1.11111H8.22758C8.59215 1.11111 8.88866 1.40762 8.88866 1.77219L8.88866 8.22775V8.2274Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94415 3.1947C7.08615 3.1947 7.22851 3.24887 7.33683 3.35754C7.55384 3.57454 7.55384 3.92626 7.33683 4.14326L6.47959 5.00051L7.33683 5.85775C7.55384 6.07476 7.55384 6.42647 7.33683 6.64348C7.11983 6.86048 6.76811 6.86048 6.55111 6.64348L5.30118 5.39354C5.08418 5.17654 5.08418 4.82482 5.30118 4.60782L6.55111 3.35789C6.65944 3.24956 6.80179 3.19505 6.9438 3.19505L6.94415 3.1947Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenuCloseIcon);
export default __webpack_public_path__ + "static/media/SidemenuCloseIcon.c38fa7b7a1849020fc8e9d8d7bf7b1b5.svg";
export { ForwardRef as ReactComponent };